import React from 'react'

import { TabPillsItem } from './TabPillsItem'
import * as S from './styled'
import type { TabPillsProps } from './types'

export const TabPills = <TValue extends string>({
  appearance = 'primary',
  size = 'medium',
  options,
  value,
  onChange,
}: TabPillsProps<TValue>) => (
  <S.Container>
    {options.map((option) => (
      <TabPillsItem
        key={option.value}
        size={size}
        appearance={appearance}
        label={option.label}
        active={option.value === value}
        onClick={() => onChange(option.value)}
      />
    ))}
  </S.Container>
)
